<template>
	<RotationLayout :rotation="rotation" :subtitle="trans('rotations.elections.voters.title')">
		<Empty v-if="voters.length === 0"/>
		<CardGrid v-else>
			<Voter v-for="voter in voters" :key="`voter-${voter.id}-${voter.status}`" :rotation="rotation" :voter="voter"/>
		</CardGrid>
	</RotationLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, ref, type Ref} from 'vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import RotationLayout from '@/Layouts/RotationLayout.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'
import Voter from '@/Components/Association/Representatives/Voter.vue'
import {type RotationVoter} from '@/Types/Periods/Rotations/RotationVoter'

const props = defineProps<{
	rotation:Rotation,
	voters:Array<RotationVoter>,
}>()

const rotation:Ref<Rotation> = ref(props.rotation)
const voters:Ref<Array<RotationVoter>> = ref(props.voters)
</script>